const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const readAuthErrorType = (value: unknown): string | undefined => {
  if (!isRecord(value)) return undefined;
  if (typeof value.error_type === 'string') return value.error_type;
  return typeof value.error === 'string' ? value.error : undefined;
};

export const getAuthErrorType = (error: unknown): string | undefined => {
  if (!isRecord(error)) return undefined;

  return (
    readAuthErrorType(error) ??
    readAuthErrorType(error.data) ??
    readAuthErrorType(
      isRecord(error.response) ? error.response.data : undefined,
    ) ??
    readAuthErrorType(error.error)
  );
};
